import { RemoteNationalService } from "../../../../data/usecases/national-service/remote-national-service";
import { NationalService } from "../../../../domain/models/national-service";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteNationalService = (): NationalService =>
  new RemoteNationalService("/national-services", makeAxiosHttpClient());
